/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { navigate, useLocation } from '@reach/router'
import React, { ReactNode, useContext, useEffect, useMemo } from 'react'
import { Tabs, TabItem, TabsContent, TabPanel } from 'react-foundation'
import UserContext from '../../UserContext'
import * as QueryString from 'query-string'
import { SaveEvent, TabChangeEvent } from './AnalyticsEvents'

export type TabMenuTabsProps = {
    title: string
    titleBadgeComponent?: ReactNode
    component: ReactNode
    showForRoles?: string[]
    hideForRoles?: string[]
}[]

type TabMenuProps = {
    title: string
    tabs: TabMenuTabsProps
    activeTab: string
    setActiveTab: React.Dispatch<string>
    searchIndex?: string
}

const TabMenu: React.FC<TabMenuProps> = ({ title, tabs, activeTab, setActiveTab, searchIndex }) => {
    const { user, hasAnyRole } = useContext(UserContext)
    const { pathname, search } = useLocation()

    const visibleTabs = useMemo(() => {
        const showTab = (hide?: string[], show?: string[]) => hide ? !hasAnyRole(...hide) : show ? hasAnyRole(...show) : true
        return tabs.filter(c => showTab(c.hideForRoles, c.showForRoles))
    }, [tabs, hasAnyRole])

    useEffect(() => {
        if (!searchIndex) return
        const ct = QueryString.parse(search)[searchIndex] as string | undefined
        if (ct === activeTab) return
        setActiveTab(ct || activeTab)
    }, [search, activeTab, searchIndex, setActiveTab])

    return <>
        <Tabs>
            {visibleTabs.map((tab, i) => <TabItem key={i} isActive={activeTab === tab.title}>
                <button onClick={() => {
                    setActiveTab(tab.title)

                    if (searchIndex) {
                        const q = QueryString.stringify({ ...QueryString.parse(search), tab: tab.title })
                        // eslint-disable-next-line no-console
                        navigate(`${pathname}?${q}`).catch(console.log)
                    }

                    SaveEvent(TabChangeEvent(user, title, tab.title, activeTab))
                    setActiveTab(tab.title)
                }}>{tab.title}{tab?.titleBadgeComponent}</button>
            </TabItem>)}
        </Tabs>

        <TabsContent>
            {visibleTabs.map((tab, i) => (
                <TabPanel key={i} isActive={activeTab === tab.title}>
                    {tab?.component}
                </TabPanel>
            ))}
        </TabsContent>
    </>
}

export default TabMenu
